import PropTypes from 'prop-types';
import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import Chart from 'react-apexcharts';
import { useTranslation } from 'react-i18next';

import { SelectComponent } from '../../../Components/shared/ReusableSmallComponents';
import SelectPeriod from '../../../Components/shared/SelectPeriod';
import { PeriodeDashboard } from '../../../data/Interfaces';
import { filtreListPeriode } from '../DashbordBackOffice';
import { sourceMission } from './StatutMissionExpert';

function TotalAoExpert({dataAllAos,width,height}){

    TotalAoExpert.propTypes = {
        dataAllAos: PropTypes.any,
        width:PropTypes.any,
        height:PropTypes.any,
    };

    const [selectedPeriodAos, setSelectedPeriodAos] = useState('thisMonth');
    const [customDateRangeAos, setCustomDateRangeAos] = useState({});
    const [selectedPeriodStatutCandidature, setSelectedPeriodStatutCandidature] = useState('thisMonth');
    const [customDateRangeStatutCandidature, setCustomDateRangeStatutCandidature] = useState({});
    const [filtreSourceMission, setFiltreSourceMission] = useState(['all']);
    const { i18n } = useTranslation();
    const [chartDataAos, setChartDataAos] = useState({
        options: {
            chart: {
                type: 'bar',
                height: 350,
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '15%',
                    endingShape: 'rounded',
                },
            },
            dataLabels: {
                enabled: false,
            },
            stroke: {
                show: true,
                width: 2,
                colors: ['transparent'],
            },
            fill: {
                opacity: 1,
            },
            yaxis: {
                type: 'numeric', // Specify the type as 'numeric'
                labels: {
                    formatter: function (val) {
                        // Use a formatter function to format the labels as integers
                        return Math.round(val);
                    },
                },
            },
        },
        series: [], // Initialize an empty array for the series
    });

    const [chartDataCandidatureCount, setChartDataCandidatureCount] = useState(
        {
            series: [],
            chart: {
                type: 'pie',
                height: 350,
                stacked: true,
                toolbar: {
                    show: true
                }
            },
            options:{
                labels:[],
                colors: ['#EFAF41', '#EC5B56','#5CC889','#FBE052','#EFAF41','#214DCE','#228b22'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        });

    //const [chartDataStatusCandidature, setChartDataStatusCandidature] = useState(
    //    {
    //        series: [],
    //        chart: {
    //            width: 380,
    //            type: 'pie',
    //        },
    //        options:{
    //            labels: [],
    //            responsive: [{
    //                breakpoint: 480,
    //                options: {
    //                    chart: {
    //                        width: 200
    //                    },
    //                    legend: {
    //                        position: 'bottom'
    //                    }
    //                }
    //            }]
    //        }
    //    });

    const getInfosGraphAosCount = (filtredList) => {
        const aoCounts = filtredList.reduce((counts, item) => {
            const date = new Date(item.dateDebutAO);
            const dateKey = date.toISOString().split('T')[0]; // Extract the date portion

            // Increment the count for the corresponding key
            counts[dateKey] = (counts[dateKey] || 0) + 1;

            return counts;
        }, {});
        const aosCount = Object.values(aoCounts);
        const keysTemp = Object.keys(aoCounts);
        //const data = [];

        // Create a map to store the index of each unique date
        //const dateIndexMap = {};

        //// Iterate over keyValues and aos arrays
        //keysTemp.forEach((keyValue, index) => {

        //    // Check if the date exists in the dateIndexMap
        //    if (!dateIndexMap[date]) {
        //    // Add the date to the dates list
        //        dates.push(date);

        //        // Set the index of the date in the dateIndexMap
        //        dateIndexMap[date] = dates.length - 1;
        //    }

        //    const existingData = data.find((item) => item.name === client);
        //    //  const tempClient=selectedClient.find((item) => item._id === client);

        //    if (existingData) {
        //    // Update the existing client's AO count at the corresponding date index
        //        existingData.data[dateIndexMap[date]] = aosCount[index];
        //    } else {
        //    // Create a new client entry in the data array
        //        const clientData = Array(dates.length).fill(0);
        //        clientData[dateIndexMap[date]] = aosCount[index];
        //        data.push({
        //            name: client,
        //            data: clientData,
        //        });
        //    }
        //});

        console.log('aosCount',aosCount,'keysTemp',keysTemp);
        return {keysTemp,aosCount};
    };

    const calculateCounts = (data) => {
        const counts = {
            analyzed_count: 0,
            interesting_count: 0,
            interview_count: 0,
            rejected_count: 0,
            retained_count: 0,
            unread_count: 0,
            converted_Count:0,
        };

        data.forEach((item) => {
            const { status } = item;
            switch (status) {
            case 'unread':
                counts.unread_count++;
                break;
            case 'analyzed':
                counts.analyzed_count++;
                break;
            case 'rejected':
                counts.rejected_count++;
                break;
            case 'interview':
                counts.interview_count++;
                break;
            case 'interesting':
                counts.interesting_count++;
                break;
            case 'retained':
                counts.retained_count++;
                break;
            case 'converted':
                counts.converted_Count++;
                break;
            default:
                break;
            }
        });

        return counts;
    };

    useEffect(() => {
        var filteredData;
        if(dataAllAos && Array.isArray(dataAllAos) && dataAllAos.length > 0){
            filteredData=dataAllAos;
            filteredData=filtreListPeriode(filteredData,selectedPeriodAos,customDateRangeAos);
            if (filtreSourceMission != 'all') {
                filteredData = filteredData.filter(
                    (item) => item.flux == filtreSourceMission
                );
            }

            console.log('selectedPeriod',selectedPeriodAos,'first filtre Ao candidature',filteredData);
            const { keysTemp,aosCount} = getInfosGraphAosCount(filteredData);
            console.log('dates',keysTemp,'data',aosCount);

            setChartDataAos(() => {
                return {
                    ...chartDataAos,
                    options:{
                        ...chartDataAos.options,
                        xaxis: {
                            categories: keysTemp,
                            type: 'datetime', // Set x-axis type to 'datetime'
                            tickAmount: 'dataPoints',
                        },

                    },
                    series: [{name:'Total Candidatures',data:aosCount}]

                };
            });
        }
    },[selectedPeriodAos,filtreSourceMission,customDateRangeAos,dataAllAos]);

    useEffect(() => {
        var filteredData;
        if(dataAllAos && Array.isArray(dataAllAos) && dataAllAos.length > 0){
            filteredData=dataAllAos;
            console.log('dataAllAos expert',dataAllAos);
            filteredData=filtreListPeriode(filteredData,selectedPeriodStatutCandidature,customDateRangeStatutCandidature);
            console.log('selectedPeriod',selectedPeriodAos,'first filtre Ao candidature',filteredData);
            const countsCandidatureStatus = calculateCounts(filteredData);
            console.log('countsCandidatureStatus',countsCandidatureStatus,'values',Object.values(countsCandidatureStatus));
            setChartDataCandidatureCount((prevState) => {
                return {
                    ...prevState,

                    series: Object.values(countsCandidatureStatus),
                    options:{
                        ...prevState.options,
                        labels:[i18n.t('Lue'),i18n.t('Intéressante'),i18n.t('À interviewer'),i18n.t('Non Retenue'),i18n.t('Retenue'),i18n.t('Non lue'),i18n.t('Mission confirmée')],

                    }
                };
            });
        }
    },[selectedPeriodStatutCandidature,customDateRangeStatutCandidature,dataAllAos]);

    return (
        <>
            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Total candidatures')}</h1>
                <div className='filtre1'>
                    <div style={{width:'50%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriodAos}
                            setSelectedPeriod={setSelectedPeriodAos}
                            setCustomDateRange={setCustomDateRangeAos}
                            listeVal={PeriodeDashboard}

                        />
                    </div>

                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataAos.options}
                        series={chartDataAos.series}
                        type="bar"
                        height={'85%'}
                        width={'100%'}
                    />
                </div>

            </div>

            <div
                className='graph1'
                style={{width:width,height:height}}
            >
                <h1 className='dashFrame5'>{i18n.t('Statut candidatures')}</h1>
                <div className='filtre1'>
                    <div style={{width:'50%'}}>
                        <SelectPeriod
                            selectedPeriod={selectedPeriodStatutCandidature}
                            setSelectedPeriod={setSelectedPeriodStatutCandidature}
                            setCustomDateRange={setCustomDateRangeStatutCandidature}
                            listeVal={PeriodeDashboard}

                        />
                    </div>
                    <div style={{width:'35%'}}>
                        <SelectComponent
                            label={i18n.t('Source')}
                            val={filtreSourceMission}
                            name='statusAoCandidatures'
                            setVal={(event)=>{
                                setFiltreSourceMission(event.target.value);
                            }}
                            listVal={sourceMission}
                        />
                    </div>

                </div>
                <div style={{height:'400px'}}>
                    <Chart
                        options={chartDataCandidatureCount.options}
                        series={chartDataCandidatureCount.series}
                        type="pie"
                        height={'85%'}
                        width={'100%'}
                    />
                </div>

            </div>

        </>
    );
}
export default TotalAoExpert;